"use client";

import { clsx } from "@trydig/ui";
import { Suspense } from "react";
import { textconfig } from "~/textconfig";
import styles from "./SearchTabs.module.css";

const DEFAULT = "all";

type SearchTabsProps = {
	facetItems: any[];
	refine: (value: string) => void;
	canRefine: boolean;
	totalCount: number;
};

const UnsuspendedSearchTabs = ({
	facetItems: productTypes,
	refine,
	canRefine,
	totalCount,
}: SearchTabsProps) => {
	const refinedItems = productTypes.filter((item) => item.isRefined);
	const activeTab = refinedItems.length === 1 ? refinedItems[0].value : DEFAULT;

	if (!canRefine || productTypes.length === 0) {
		return null;
	}

	return (
		<nav className={styles.root}>
			<button
				className={clsx(styles.tag, activeTab === DEFAULT && styles.active)}
				onClick={() => {
					productTypes.forEach((item) => {
						if (item.isRefined) {
							refine(item.value);
						}
					});
				}}
			>
				{textconfig.display.tabs[DEFAULT as keyof typeof textconfig.display.tabs] ?? "Alle"}{" "}
			</button>
			{productTypes.map((item) => (
				<button
					key={item.value}
					className={clsx(styles.tag, activeTab === item.value && styles.active)}
					onClick={() => {
						productTypes.forEach((productType) => {
							if (productType.isRefined && productType.value !== item.value) {
								refine(productType.value);
							}
						});

						if (!item.isRefined) {
							refine(item.value);
						}
					}}
				>
					{textconfig.display.tabs[item.value as keyof typeof textconfig.display.tabs] ??
						item.value}{" "}
					({item.count})
				</button>
			))}
		</nav>
	);
};

export const SearchTabs = (props: SearchTabsProps) => (
	<Suspense
		fallback={
			<div>
				<button className={styles.tag} key={"fallback--key--" + "Alle"}>{`${"Alle"})`}</button>
			</div>
		}
	>
		<UnsuspendedSearchTabs {...props} />
	</Suspense>
);
